import { Box, Grid } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import SingleUserRow from 'components/molecules/FollowModal/SingleUserRow';
import { selectAuth } from 'features/auth/authSlice';
import React from 'react';

const SubscribedTo = () => {
  const authState = useAppSelector(selectAuth);
  const user0 = require('assets/Profile/buku_default_avatar.png');

  return (
    <Grid width={'80%'}>
      <h1 style={{ color: 'white', fontWeight: 600 }}>Creators</h1>
      {authState.subscribedTo &&
        authState.subscribedTo.map(user => {
          return (
            <Box key={user.id}>
              <SingleUserRow
                avatarSrc={user.to.avatar || user0}
                username={user.to.username}
                userId={user.to.id}
                data={user.to}
                followed={
                  authState.following
                    ? authState.following.some(
                        following =>
                          following.following.id === user.id &&
                          !following.unfollowed
                      )
                    : false
                }
              />
            </Box>
          );
        })}
    </Grid>
  );
};

export default SubscribedTo;
